module.exports = __webpack_public_path__ + "officialStatic/img/index-product-platform.5dd25fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-platform.png
// module id = RE1A
// module chunks = 0